<template>
  <div id="app" class="">
    <formulari :lang="lang"/>
  </div>
</template>

<script>
import Formulari from './components/formulari.vue'
//import {Validator} from "vee-validate";
import es from 'vee-validate/dist/locale/es';
import ca from 'vee-validate/dist/locale/ca';
import en from 'vee-validate/dist/locale/en';

//Validator.localize('es',es);

export default {
  name: 'App',
  components: {
    formulari: Formulari
  },
  data() {
    return {
      lang: 'es'
    }
  },
  created(){
    let urlParams = new URLSearchParams(window.location.search);
    if(urlParams.has('lang') && ['ca','es','en'].findIndex(item => item === urlParams.get('lang')) > 0 ) this.lang = this.$i18n.locale = urlParams.get('lang');
    else this.$i18n.locale = this.lang;

    if(this.lang === 'es') this.$validator.localize(es);
    else if(this.lang === 'en') this.$validator.localize(en);
    else this.$validator.localize(ca);
  }
}
</script>